<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0" *ngIf="oappService.solonetsolin">Copyright 2022 © Netsolin All rights reserved.</p>
      <p class="mb-0" *ngIf="!oappService.solonetsolin">Copyright 2022 © Cercanos All rights reserved.</p>
    </div>
    <div class="col-md-6">
      <p class="pull-right mb-0">Hand crafted & made with<i class="fa fa-heart"></i></p>
    </div>
  </div>
</div>
